import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);


/* layout */
import layout from "../views/layout/layout";
import EduGroupMgt from "../views/eduGroup/EduGroupMgt";



Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: layout,
      name: "个人中心",
      children: [
        {
          path: "/index/indexPage",
          component: _import("index/indexPage"),
          name: "首页"
        },
        {
          path: "/index/csindex",
          component: _import("index/csindex"),
          name: "首页22"
        },
        {
          path: "/index/grsb",
          component: _import("index/grsb"),
          name: "我的申报"
        },
        {
          path: "/index/ys",
          component: _import("index/ys"),
          name: "ys"
        },
        {
          path: "/index/wdht",
          component: _import("index/wdht"),
          name: "我的合同"
        },
        {
          path: "/index/wdcg",
          component: _import("index/wdcg"),
          name: "我的成果"
        },
      ]
    },
    {
      path: "/platform",
      component: layout,
      name: "产教融合平台管理",
      children: [
        {
          path: "/platform/PlatformManage",
          component: _import("platform/PlatformManage"),
          name: "平台管理"
        }
      ]
    },
    {
      path: "/council",
      component: layout,
      name: "理事会管理",
      children: [
        {
          path: "/council/councilMembers",
          component: _import("council/councilMembers"),
          name: "理事会成员管理"
        },
        {
          path: "/council/CouncilMinutes",
          component: _import("council/CouncilMinutes"),
          name: "会议纪要文件管理"
        },
        {
          path: "/council/CouncilNotice",
          component: _import("council/CouncilNotice"),
          name: "通知公告管理"
        },
        {
          path: "/council/CouncilNews",
          component: _import("council/CouncilNews"),
          name: "新闻动态管理"
        },
        {
          path: "/council/CouncilNewsCheckOk",
          component: _import("council/CouncilNewsCheckOk"),
          name: "成员单位资讯列表"
        },
        {
          path: "/council/CouncilCoordinationOk",
          component: _import("council/CouncilCoordinationOk"),
          name: "成员单位合作需求列表"
        },
        {
          path: "/council/CouncilNewsCheck",
          component: _import("council/CouncilNewsCheck"),
          name: "成员单位资讯审核"
        },
        {
          path: "/council/CouncilCoordination",
          component: _import("council/CouncilCoordination"),
          name: "成员单位合作需求审核"
        },
        {
          path: "/council/CouncliSet",
          component: _import("council/CouncliSet"),
          name: "理事会设置"
        },
      ]
    },
    {
      path: "/industrialCollege",
      component: layout,
      name: "产业学院管理",
      children: [
        {
          path: "/industrialCollege/IndustrialCollegeSet",
          component: _import("industrialCollege/IndustrialCollegeSet"),
          name: "产业学院设置"
        },
        {
          path: "/industrialCollege/IndustrialCollegeMembers",
          component: _import("industrialCollege/IndustrialCollegeMembers"),
          name: "产业学院成员管理"
        }
      ]
    },
    {
      path: "/consortium",
      component: layout,
      name: "联合体管理",
      children: [
        {
          path: "/consortium/ConsortiumSet",
          component: _import("consortium/ConsortiumSet"),
          name: "联合体设置"
        },
        {
          path: "/consortium/ConsortiumMembers",
          component: _import("consortium/ConsortiumMembers"),
          name: "联合体成员管理"
        }
      ]
    },
    {
      path: "/community",
      component: layout,
      name: "共同体管理",
      children: [
        {
          path: "/community/CommunitySet",
          component: _import("community/CommunitySet"),
          name: "共同体设置"
        },
        {
          path: "/community/CommunityMembers",
          component: _import("community/CommunityMembers"),
          name: "共同体成员管理"
        }
      ]
    },
    {
      path: "/practiceCenter",
      component: layout,
      name: "产教融合实践中心管理",
      children: [
        {
          path: "/practiceCenter/PracticeCenterSet",
          component: _import("practiceCenter/PracticeCenterSet"),
          name: "产教融合实践中心设置"
        },
        {
          path: "/practiceCenter/PracticeCenterMembers",
          component: _import("practiceCenter/PracticeCenterMembers"),
          name: "产教融合实践中心成员管理"
        }
      ]
    },
    {
      path: "/eduGroup",
      component: layout,
      name: "职教集团管理",
      children: [
        {
          path: "/eduGroup/EduGroupMgt",
          component: _import("eduGroup/EduGroupMgt"),
          name: "集团设置",
          children: [
          ]
        },
        {
          path: "/eduGroup/EduGroupMemberMgt",
          component: _import("eduGroup/EduGroupMemberMgt"),
          name: "集团成员管理"
        },
        {
          path: "/eduGroup/EduGroupMinutes",
          component: _import("eduGroup/EduGroupMinutes"),
          name: "会议纪要文件管理"
        },
        {
          path: "/eduGroup/EduGroupNotice",
          component: _import("eduGroup/EduGroupNotice"),
          name: "集团通知公告管理"
        },
        {
          path: "/eduGroup/EduGroupNewsMgtGroup",
          component: _import("eduGroup/EduGroupNewsMgtGroup"),
          name: "集团新闻动态管理"
        },
        {
          path: "/eduGroup/EduGroupNewsMgt",
          component: _import("eduGroup/EduGroupNewsMgt"),
          name: "成员新闻动态管理"
        },
        {
          path: "/eduGroup/EduGroupCoNeed",
          component: _import("eduGroup/EduGroupCoNeed"),
          name: "成员合作需求管理"
        },
        {
          path: "/eduGroup/EduGroupMemberNewsAudit",
          component: _import("eduGroup/EduGroupMemberNewsAudit"),
          name: "成员新闻动态审核"
        },
        {
          path: "/eduGroup/EduGroupMemberCoAudit",
          component: _import("eduGroup/EduGroupMemberCoAudit"),
          name: "成员合作需求审核"
        },
      ]
    },
    {
      path: "/xxptsz",
      component: layout,
      name: "平台信息设置",
      children: [
        {
          path: "/xxptsz/lbtsz",
          component: _import("xxptsz/lbtsz"),
          name: "banner设置"
        },
        {
          path: "/xxptsz/dhsz",
          component: _import("xxptsz/dhsz"),
          name: "导航设置"
        },
        {
          path: "/xxptsz/lmsz",
          component: _import("xxptsz/lmsz"),
          name: "栏目设置"
        },
        {
          path: "/xxptsz/ljsz",
          component: _import("xxptsz/ljsz"),
          name: "链接设置"
        },
        {
          path: "/xxptsz/hzxq",
          component: _import("xxptsz/hzxq"),
          name: "合作需求"
        },
        {
          path: "/xxptsz/xwdt",
          component: _import("xxptsz/xwdt"),
          name: "新闻动态"
        },
        {
          path: "/xxptsz/tzgg",
          component: _import("xxptsz/tzgg"),
          name: "通知公告"
        },
        {
          path: "/xxptsz/zcwj",
          component: _import("xxptsz/zcwj"),
          name: "政策文件"
        },
        {
          path: "/xxptsz/glwj",
          component: _import("xxptsz/glwj"),
          name: "管理文件"
        },
        {
          path: "/xxptsz/jcxxsz",
          component: _import("xxptsz/jcxxsz"),
          name: "基础信息设置"
        },
        {
          path: "/xxptsz/PlatResourceAppliMgt",
          component: _import("xxptsz/PlatResourceAppliMgt"),
          name: "平台资源申请管理"
        },
        {
          path: "/xxptsz/FileDownload",
          component: _import("xxptsz/FileDownload"),
          name: "下载文件管理"
        },

      ]
    },
    {
      path: "/xqhz",
      component: layout,
      name: "校企合作管理",
      children: [
        {
          path: "/xqhz/NoticeControl",
          component: _import("xqhz/NoticeControl"),
          name: "通知公告管理"
        },
        {
          path: "/xqhz/News",
          component: _import("xqhz/News"),
          name: "新闻动态管理"
        },
        {
          path: "/xqhz/NewsCheckOk",
          component: _import("xqhz/NewsCheckOk"),
          name: "成员单位资讯列表"
        },
        {
          path: "/xqhz/CoordinationOK",
          component: _import("xqhz/CoordinationOK"),
          name: "成员单位合作需求列表"
        },
        {
          path: "/xqhz/NewsCheck",
          component: _import("xqhz/NewsCheck"),
          name: "成员单位资讯审核"
        },
        {
          path: "/xqhz/Coordination",
          component: _import("xqhz/Coordination"),
          name: "成员单位合作需求审核"
        },
        {
          path: "/xqhz/xqhzsz",
          component: _import("xqhz/Xqhzsz"),
          name: "校企合作设置"
        },
        {
          path: "/xqhz/CaseMgt",
          component: _import("xqhz/CaseMgt"),
          name: "校企合作特色案例"
        },
        {
          path: "/xqhz/TableDownloadMgt",
          component: _import("xqhz/TableDownloadMgt"),
          name: "校企合作表格下载"
        },
        {
          path: "/xqhz/RulesList",
          component: _import("xqhz/RulesList"),
          name: "校企合作规章制度"
        },
      ]
    },
    {
      path: "/members",
      component: layout,
      name: "成员账号管理",
      children: [
        {
          path: "/members/councilMember",
          component: _import("members/councilMember"),
          name: "理事会成员"
        },
        {
          path: "/members/groupMember",
          component: _import("members/groupMember"),
          name: "职教集团（联盟）成员"
        },
        {
          path: "/members/enterpriseMember",
          component: _import("members/enterpriseMember"),
          name: "合作企业成员"
        },
        {
          path: "/members/industrialMember",
          component: _import("members/industrialMember"),
          name: "产业学院成员"
        },
        {
          path: "/members/consortiumMember",
          component: _import("members/consortiumMember"),
          name: "联合体成员"
        },
        {
          path: "/members/communityMember",
          component: _import("members/communityMember"),
          name: "共同体成员"
        },
        {
          path: "/members/practiceMember",
          component: _import("members/practiceMember"),
          name: "实践中心成员"
        }
      ]
    },
    {
      path: "/message",
      component: layout,
      name: "消息通知管理",
      children: [
        {
          path: "/Message",
          component: _import("message/Message"),
          name: "消息通知管理"
        },
        {
          path: "/MessageDetails",
          component: _import("message/MessageDetails"),
          name: "MessageDetails"
        },
      ]
    },
    {
      path: "/kyxmwd",
      component: layout,
      name: "我的科研项目",
      children: [
        {
          path: "/kyxmwd/kyxmgl",
          component: _import("kyxmwd/kyxmgl"),
          name: "科研项目"
        },
        {
          path: "/kyxmwd/bglgl",
          component: _import("kyxmwd/bglgl"),
          name: "报告类"
        },
        {
          path: "/kyxmwd/cglgl",
          component: _import("kyxmwd/cglgl"),
          name: "成果类"
        },
        {
          path: "/kyxmwd/cglgl",
          component: _import("kyxmwd/cglgl"),
          name: "成果类"
        },
            {
          path: "/kyxmwd/lwgl",
          component: _import("kyxmwd/lwgl"),
          name: "论文"
        },
         {
          path: "/kyxmwd/xszzgl",
          component: _import("kyxmwd/xszzgl"),
          name: "学术著作"
        },
         {
          path: "/kyxmwd/xsjlgl",
          component: _import("kyxmwd/xsjlgl"),
          name: "学术交流"
        },
         {
          path: "/kyxmwd/zscqgl",
          component: _import("kyxmwd/zscqgl"),
          name: "知识产权"
        },
      ]
    },
    {
      path: "/serviceRating",
      component: layout,
      name: "产教融合工作考核",
      children: [

        {
          path: "/serviceRating/yearExamineList",
          component: _import("serviceRating/yearExamineList"),
          name: "年度工作考核添加"
        },
        {
          path: "/serviceRating/examineIntegralRanking",
          component: _import("serviceRating/examineIntegralRanking"),
          name: "考核排行榜"
        },
        {
          path: "/serviceRating/addYearExamineItem",
          component: _import("serviceRating/addYearExamineItem"),
          name: "addRating"
        }, {
          path: "/serviceRating/scoringWork",
          component: _import("serviceRating/scoringWork"),
          name: "年度工作考核评分"

        }
      ]
    },
    {
      path: "/reports",
      component: layout,
      name: "统计报表",
      children: [
        {
          path: "/reports/reportsList",
          component: _import("reports/reportsList1"),
          name: "统计报表列表"
        },
        {
          path: "/reports/reportDetail",
          component: _import("reports/reportDetail"),
          name: "reportDetail"
        },
      ]
    },
    {
      path: "/xmgl",
      component: layout,
      name: "项目管理",
      children: [
        {
          path: "/xmgl/xmlbgl",
          component: _import("xmgl/xmlbgl"),
          name: "xmlbgl"
        },
        {
          path: "/xmgl/htkhxq",
          component: _import("xmgl/htkhxq"),
          name: "htkhxq"
        },
        {
          path: "/xmgl/jt",
          component: _import("xmgl/jt"),
          name: "jt"
        },
        {
          path: "/xmgl/xmxq",
          component: _import("xmgl/xmxq"),
          name: "xmxq"
        },
        {
          path: "/xmgl/ndzb",
          component: _import("xmgl/ndzb"),
          name: "ndzb"
        },
        {
          path: "/xmgl/htlbgl",
          component: _import("xmgl/htlbgl"),
          name: "合同列表管理"
        },
        {
          path: "/xmgl/htshlb",
          component: _import("xmgl/htshlb"),
          name: "合同审核列表管理"
        },
        {
          path: "/xmgl/cglbgl",
          component: _import("xmgl/cglbgl"),
          name: "成果列表管理"
        },
        {
          path: "/xmgl/cgshlb",
          component: _import("xmgl/cgshlb"),
          name: "成果审核列表"
        },
        {
          path: "/xmgl/cgxz",
          component: _import("xmgl/cgxz"),
          name: "成果新增"
        },
        {
          path: "/xmgl/settigItemSetting",
          component: _import("xmgl/settigItemSetting"),
          name: "成果分类"
        },
        {
          path: "/xmgl/xmsb",
          component: _import("xmgl/xmsb"),
          name: "项目申报页面"
        },
        {
          path: "/xmgl/htxz",
          component: _import("xmgl/htxz"),
          name: "合同新增页面"
        },
        {
          path: "/xmgl/htxq",
          component: _import("xmgl/htxq"),
          name: "htxq"
        },
        {
          path: "/xmgl/xmshlb",
          component: _import("xmgl/xmshlb"),
          name: "项目审核列表"
        },
        {
          path: "/htgl/HtyearExamine",
          component: _import("xmgl/HtyearExamine"),
          name: "HtyearExamine"
        },
        {
          path: "/htgl/EJyearExamine",
          component: _import("xmgl/EJyearExamine2"),
          name: "EJyearExamine"
        },
      ]

    },
    {
      path: "/kyxm",
      component: layout,
      name: "项目管理",
      children: [
        {
          path: "/kyxm/bgl/bglxz",
          component: _import("kyxm/bgl/bglxz"),
          name: "bglxz"
        },
        {
          path: "/kyxm/bgl/bglgl",
          component: _import("kyxm/bgl/bglgl"),
          name: "bglgl"
        },
        {
          path: "/kyxm/cgl/cglxz",
          component: _import("kyxm/cgl/cglxz"),
          name: "cglxz"
        },
        {
          path: "/kyxm/cgl/cglgl",
          component: _import("kyxm/cgl/cglgl"),
          name: "cglgl"
        },
        {
          path: "/kyxm/kyxm1/kyxmxz",
          component: _import("kyxm/kyxm/kyxmxz"),
          name: "kyxmxz"
        },
        {
          path: "/kyxm/kyxm1/kyxmgl",
          component: _import("kyxm/kyxm/kyxmgl"),
          name: "kyxmgl"
        },

        {
          path: "/kyxm/lw/lwxz",
          component: _import("kyxm/lw/lwxz"),
          name: "lwxz"
        },
        {
          path: "/kyxm/lw/lwgl",
          component: _import("kyxm/lw/lwgl"),
          name: "lwgl"
        },


        {
          path: "/kyxm/xsjl/xsjlxz",
          component: _import("kyxm/xsjl/xsjlxz"),
          name: "xsjlxz"
        },
        {
          path: "/kyxm/xsjl/xsjlgl",
          component: _import("kyxm/xsjl/xsjlgl"),
          name: "xsjlgl"
        },


        {
          path: "/kyxm/xszz/xszzxz",
          component: _import("kyxm/xszz/xszzxz"),
          name: "xszzxz"
        },
        {
          path: "/kyxm/xszz/xszzgl",
          component: _import("kyxm/xszz/xszzgl"),
          name: "xszzgl"
        },


        {
          path: "/kyxm/zscq/zscqgl2",
          component: _import("kyxm/zscq/zscqxz"),
          name: "zscqxz"
        },
        {
          path: "/kyxm/zscq/zscqgl",
          component: _import("kyxm/zscq/zscqgl"),
          name: "zscqgl"
        },

      ]
    },
    {
      path: "/kyxm",
      component: layout,
      name: "项目管理",
      children: [
        {
          path: "/kyxm/bgl/bglxz",
          component: _import("kyxm/bgl/bglxz"),
          name: "bglxz"
        },
        {
          path: "/kyxm/bgl/bglgl",
          component: _import("kyxm/bgl/bglgl"),
          name: "bglgl"
        },
        {
          path: "/kyxm/cgl/cglxz",
          component: _import("kyxm/cgl/cglxz"),
          name: "cglxz"
        },
        {
          path: "/kyxm/cgl/cglgl",
          component: _import("kyxm/cgl/cglgl"),
          name: "cglgl"
        },
        {
          path: "/kyxm/kyxm1/kyxmxz",
          component: _import("kyxm/kyxm/kyxmxz"),
          name: "kyxmxz"
        },
        {
          path: "/kyxm/kyxm1/kyxmgl",
          component: _import("kyxm/kyxm/kyxmgl"),
          name: "kyxmgl"
        },

        {
          path: "/kyxm/lw/lwxz",
          component: _import("kyxm/lw/lwxz"),
          name: "lwxz"
        },
        {
          path: "/kyxm/lw/lwgl",
          component: _import("kyxm/lw/lwgl"),
          name: "lwgl"
        },


        {
          path: "/kyxm/xsjl/xsjlxz",
          component: _import("kyxm/xsjl/xsjlxz"),
          name: "xsjlxz"
        },
        {
          path: "/kyxm/xsjl/xsjlgl",
          component: _import("kyxm/xsjl/xsjlgl"),
          name: "xsjlgl"
        },


        {
          path: "/kyxm/xszz/xszzxz",
          component: _import("kyxm/xszz/xszzxz"),
          name: "xszzxz"
        },
        {
          path: "/kyxm/xszz/xszzgl",
          component: _import("kyxm/xszz/xszzgl"),
          name: "xszzgl"
        },


        {
          path: "/kyxm/zscq/zscqgl2",
          component: _import("kyxm/zscq/zscqxz"),
          name: "zscqxz"
        },
        {
          path: "/kyxm/zscq/zscqgl",
          component: _import("kyxm/zscq/zscqgl"),
          name: "zscqgl"
        },

      ]
    },
    {
      path: "/settings",
      component: layout,
      name: "系统设置",
      children: [
        {
          path: "/settings/roleManagement",
          component: _import("settings/roleManagement"),
          name: "角色管理"
        },
        {
          path: "/settings/userAdmin",
          component: _import("settings/userAdmin"),
          name: "用户管理"
        },
      ]
    },
    {
      path: '/redirect',
      component: _import('redirect/redirect/index'),
      name: '跳转'
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js